/**
 * Contact Section Component
 * Displays contact information in 4 columns with footer
 * Uses negative colors (dark background with light text)
 */

export function renderContactSection(): HTMLElement {
  const section = document.createElement('section');
  section.id = 'contact';
  section.className = 'contact-section';

  section.innerHTML = `
    <div class="contact-container">
      <!-- Contact Content - 4 Columns -->
      <div class="contact-grid">
        <!-- Column 1: Logo and Tagline -->
        <div class="contact-column">
          <div class="contact-logo">
            <img src="/besafe_color_negativo.svg" alt="BeSafe Logo" class="logo-image" />
          </div>
          <p class="contact-tagline" data-i18n="contact.tagline">
            Respaldo integral para propietarios, inmobiliarias y arrendatarios, combinando análisis legal, financiero y operativo para garantizar procesos confiables
          </p>
        </div>

        <!-- Column 2: Navigation Links -->
        <div class="contact-column">
          <h3 class="column-title" data-i18n="contact.navigation.title">Navegación</h3>
          <nav class="contact-nav">
            <a href="#services" class="nav-link" data-i18n="contact.navigation.services">Servicios</a>
            <a href="#about" class="nav-link" data-i18n="contact.navigation.about">Nosotros</a>
            <a href="#faq" class="nav-link" data-i18n="contact.navigation.faq">Preguntas</a>
            <a href="#contact" class="nav-link" data-i18n="contact.navigation.contact">Contacto</a>
          </nav>
        </div>


        <!-- Column 4: Contact Information -->
        <div class="contact-column">
          <h3 class="column-title" data-i18n="contact.info.title">Información de Contacto</h3>
          <div class="contact-info">
            <div class="info-item">
              <span class="info-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </span>
              <p class="info-text" data-i18n="contact.info.address">El Centro Ejecutivo en El Poblado, Medellín, está ubicado en la Calle 4 Sur # 43A-195, en el sector Patio Bonito. Se encuentra al lado del Centro Comercial Oviedo. <b>OFICINA 237</b></p>
            </div>
            <div class="info-item">
              <span class="info-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </span>
              <a href="https://wa.me/573124453260" class="info-link" 06rget="_blank" rel="noopener noreferrer">
                <span data-i18n="contact.info.whatsapp">+57 3124453206</span>
              </a>
            </div>
            <div class="info-item">
              <span class="info-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </span>
              <a href="mailto:apoyojuridico@apriorilegal.co" class="info-link">
                <span data-i18n="contact.info.email">apoyojuridico@apriorilegal.co</span>
              </a>
            </div>
            <div class="info-item">
              <span class="info-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              </span>
              <p class="info-text" data-i18n="contact.info.schedule">Lunes a Viernes: 8:00 AM - 4:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Allies -->
      <div class="footer-allies">
        <h3 class="allies-title" data-i18n="contact.allies.title">Aliados</h3>
        <div class="allies-logos">
          <a href="https://lonja.org.co" target="_blank" rel="noopener noreferrer" class="ally-logo-link" aria-label="Lonja de Propiedad Raíz">
            <img
              src="https://lonja.org.co/wp-content/uploads/2025/02/logo-lonja-footer.webp"
              alt="Lonja de Propiedad Raíz"
              class="ally-logo"
              loading="lazy"
            />
          </a>
        </div>
      </div>

      <!-- Footer -->
      <footer class="footer">
        <div class="footer-content">
          <!-- Copyright -->
          <div class="footer-section">
            <p class="copyright" data-i18n="contact.footer.copyright">
              © 2026 BeSafe – A priori Legal – Todos los derechos reservados
            </p>
          </div>

          <!-- Policy Links -->
          <div class="footer-section">
            <a href="#" class="footer-link" data-privacy-link data-i18n="contact.footer.privacy">Política de privacidad</a>
            <span class="footer-separator">|</span>
            <a href="#" class="footer-link" data-privacy-link data-i18n="contact.footer.dataProtection">Política de protección de datos</a>
          </div>

          <!-- Developer Credit -->
          <div class="footer-section">
            <p class="developer-credit" data-i18n="contact.footer.developer">
              Desarrollado por Jaibana IT
            </p>
          </div>
        </div>
      </footer>
    </div>
  `;

  return section;
}
